import { useAuth0 } from '@auth0/auth0-react'
import { useStoreActions, useStoreState } from '@mortgage-pos/ui/store'
import { handleSignInOutClick } from '@mortgage-pos/ui/utils/authenticationHelpers'
import React, { FC } from 'react'
import Button, { ButtonVariants } from './Button'

const SignInButton: FC = () => {
  const { isAuthenticated } = useStoreState((state) => state.authentication)
  const { logout } = useStoreActions((store) => store.authentication)
  const { loginWithRedirect, logout: auth0Logout } = useAuth0()

  const handleClick = () => {
    handleSignInOutClick(
      isAuthenticated,
      loginWithRedirect,
      auth0Logout,
      logout
    )
  }

  return (
    <Button
      variant={ButtonVariants.signIn}
      content={isAuthenticated ? 'Sign Out' : 'Sign In'}
      onClick={handleClick}
    />
  )
}

export default SignInButton
